module.exports = __webpack_public_path__ + "static/img/main6_4.83098a92.png";